function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 11.23 9.1" {...props}><title>share</title><g data-name="Ebene 2"><g data-name="Ebene 1" fill="none" stroke="#93a7bb" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.8"><path d="M10.33 4.67H.9M10.33 4.67L6.26.9M6.2 8.2l4.13-3.53" /></g></g></svg>;
});